module.exports = __webpack_public_path__ + "static/assets/3d371bf7047aec80889e94139d89cbc5.svg";